import { Injectable } from "@angular/core";
import { ListMetadata } from "app/models/list-metadata.model";
import { HttpClientService } from "app/services/httpClient/httpclient.service";
import { Observable } from "rxjs";
import { ActionDetails, ActionDto, ActionTypeDto, BudgetTypeDto, Campaign3Campaign, CampaignTypeDto, DistributionCluster3, DistributionListCluster, DistributionListDetails, MessageInstanceActionStatusDto } from "../models/campaign-3.model";
import { Acm } from "app/models/loyalty-acm.model";






@Injectable()
export class Campaign3TestService {

  private apiUrl = '/koncentro-promo/campaign?offset=0&limit=10';
  private statusUrl = '/koncentro-promo/campaign/campaign-status';
  private campaignTypeUrl = '/koncentro-promo/campaign/campaign_type';
  private campaignActionUrl = '/koncentro-promo/campaign/message-instance?campaign_id=';
  private singleCampaignUrl = '/koncentro-promo/campaign?id=';
  private actionTypeUrl = '/koncentro-promo/campaign/action_type';
  private saveEntityUrl = '/koncentro-promo/campaign';
  private editEntityUrl = '/koncentro-promo/campaign/';
  private actionURL = "/koncentro-promo/campaign/message-instance";
  private baseUrl = 'koncentro-promo/campaign';
  private singleAction = '/koncentro-promo/campaign/message-instance/getMessageInstanceSingleObject?message_instance_id='
  private actionStatus = '/koncentro-promo/campaign/message-instance-action-status/'
  private actionStatusUrl = '/koncentro-promo/campaign/message-instance?status_id='
  private deleteCampaignUrl = '/koncentro-promo/campaign/'



  data;
  statusData;
  budgetData;
  campaignType;
  actionList;
  actionListTest;
  actionTypes;
  private budgetUrl = '/koncentro-promo/campaign/budget-type'



  constructor(private http: HttpClientService) { }

  /*funzione che riempie la kontable*/
  //todo attenzione ho inserito filtertyper in search
  list(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: Array<any>, metadata: ListMetadata }> {

    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);

    return this.http.getPaged(this.baseUrl + '?' + params.toString());
  }
  /* TODO attenzione valutare se reare una nuova buildListParams fatta a misura per questa chiamata specifica */
  listActions(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: Array<any>, metadata: ListMetadata }> {

    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);

    return this.http.getPaged(this.actionURL + '?' + params.toString());
  }
  //tutte le azioni
  getAllActions(): Observable<{ data: Array<ActionDto>, metadata: ListMetadata }> {
    this.data = this.http.getPaged(this.actionURL);
    return this.data;
  }

  /* stessa funzione che riempie i dati in tabella tutte le campagne */
  getCampaignData(): Observable<Array<Campaign3Campaign>> {
    this.data = this.http.getPaged(this.apiUrl);
    return this.data;
  }
  //ritorna vuota al momento
  /* servizio che recupera la lista di elementi dentro il filtro dello status */
  getCampaignStatus(): Observable<{ data: Array<any>, metadata: ListMetadata }> {
    this.statusData = this.http.getPaged(this.statusUrl);
    return this.statusData;
  }
  getBudgetType(): Observable<{ data: Array<BudgetTypeDto>, metadata: ListMetadata }> {
    this.budgetData = this.http.getPaged(this.budgetUrl);
    return this.budgetData;
  }

  getActionStatus(): Observable<{ data: Array<MessageInstanceActionStatusDto>, metadata: ListMetadata }> {
    this.statusData = this.http.getPaged(this.actionStatus);
    return this.statusData;
  }

  /* servizio che recupera la lista di elementi dentro il filtro del campaign Type */
  getCampaignType(): Observable<{ data: Array<CampaignTypeDto>, metadata: ListMetadata }> {
    this.campaignType = this.http.getPaged(this.campaignTypeUrl);
    return this.campaignType;
  }

  /* Servizio che ritorna la lista di azioni legate alla campagna */
  getCampaignActions(id: number): Observable<ActionDto[]> {
    this.actionList = this.http.getPaged(this.campaignActionUrl + id.toString());
    return this.actionList;
  }
  /* Servizio che ritorna la lista di actiontype per i filtri di actionList */
  getActionTypes(): Observable<{ data: Array<ActionTypeDto>, metadata: ListMetadata }> {
    this.actionTypes = this.http.getPaged(this.actionTypeUrl);
    return this.actionTypes;
  }

  /* Servizio che ritorna i dati della singola campagna una volta effettuato l'edit */
  getSingleCampaign(id: number): Observable<{ data: Array<Campaign3Campaign>, metadata: ListMetadata }> {
    return this.http.getPaged(this.singleCampaignUrl + id.toString());
  }


  //Attenzione  a mappare qui che la singola action ha un sacco di informazioni
  getSingleAction(id: number): Observable<ActionDetails> {
    return this.http.getPaged(this.singleAction + id.toString());
  }

  // Funzione per salvare una nuova campagna
  saveNewCampaign(payload: any) {
    return this.http.postPaged(this.saveEntityUrl, payload);
  }

  editCampaign(payload: any, id: number) {
    return this.http.putPaged(this.editEntityUrl + id.toString(), payload);
  }

  fetchActionStatus(id: number): Observable<any> {
    return this.http.getPaged(this.actionStatusUrl + id.toString());
  }
  deleteCampaign(id: number): Observable<any> {
    return this.http.deleteAdv(this.deleteCampaignUrl + id.toString());
  }
  getAllCampaigns(): Observable<Array<Campaign3Campaign>> {
    return this.http.get(`${this.baseUrl}`);
  }
  acmUrl = "/koncentro-loyalty/acm/acm_channel?acm_id="
  //GET /koncentro-loyalty/acm/acm_channel/{id_acm_channel}
  getAcmLoyChannelList(id): Observable<Array<AcmChannel>> {
    return this.http.get(this.acmUrl + id.toString());
  }
  distributionUrl = "/koncentro-promo/campaign/distribution_list/getDistributionListClusters?distribution_list_id="
  //GET /koncentro-loyalty/acm/acm_channel/{id_acm_channel}
  getDistributionListDetails(id): Observable<Array<DistributionCluster3>> {
    return this.http.get(this.distributionUrl + id.toString());
  }

  deleteAction(actionId: number) {
    return this.http.delete(`${this.baseUrl}/message-instance/${actionId}`);
  }




}

export class AcmDetail {
  acmCode: string;
  acmDescription: string;
  acmTypeCode: number;
  acmTypeDescription: string;
  acmTypeId: number; // Renamed from acmTypeid to acmTypeId to match TypeScript naming conventions
  acm_id: number; // Renamed from acm_id to acmId to match TypeScript naming conventions
  channelCode: string;
  channelDescription: string;
  channel_id: number; // Renamed from channel_id to channelId to match TypeScript naming conventions
  date_end: string; // Renamed from date_end to dateEnd to match TypeScript naming conventions
  date_pti_end: string; // Renamed from date_pti_end to datePtiEnd to match TypeScript naming conventions
  date_pti_start: string; // Renamed from date_pti_start to datePtiStart to match TypeScript naming conventions
  date_start: string; // Renamed from date_start to dateStart to match TypeScript naming conventions
  flg_dpl: string | null;
  flg_ext_circ: string; // Renamed from flg_ext_circ to flgExtCirc to match TypeScript naming conventions
  flg_kf: string | null;
  flg_state: string;
  flg_visible: string;
  id: number;
  ts_del: string | null; // Renamed from ts_del to tsDel to match TypeScript naming conventions
  ts_ins: string | null; // Renamed from ts_ins to tsIns to match TypeScript naming conventions
  ts_upd: string | null; // Renamed from ts_upd to tsUpd to match TypeScript naming conventions
  user_del_id: number | null; // Renamed from user_del_id to userDelId to match TypeScript naming conventions
  user_ins_id: number | null; // Renamed from user_ins_id to userInsId to match TypeScript naming conventions
  user_upd_id: number | null;
}

export class AcmChannel {
  acmCode: string;
  acmDescription: string;
  acmTypeCode: number;
  acmTypeDescription: string;
  acmTypeid: number;
  acm_id: number;
  channelCode: string;
  channelDescription: string;
  channel_id: number;
  checked: boolean;
  date_end: string;
  date_pti_end: string;
  date_pti_start: string;
  date_start: string;
  flg_dpl: any;
  flg_ext_circ: string;
  flg_kf: any;
  flg_state: string;
  flg_visible: string;
  id: number;
  menuActivated: boolean;
  ts_del: any;
  ts_ins: any;
  ts_upd: any;
  user_del_id: any;
  user_ins_id: any;
  user_upd_id: any;
}



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/services/campaign3testservice.ts